import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Subject } from 'rxjs';
import { NotificationAddRecipientService } from './notification-add-recipients-template.service';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { CommonModule } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';

export interface TableElement {  
  customerID: number | string;  
  customerName: string;  
  customerContactName: string;  
  customerContactEmail: string;  
  source: string;
  iconSets: string;  
  disabled?:boolean;
  internalContact?: boolean;
}

@Component({
  selector: 'dl-notification-add-recipients-template',
   standalone: true,
     imports: [OneWebComponentsAngularModule,CommonModule,FormsModule,ReactiveFormsModule],
  templateUrl: './notification-add-recipients-template.component.html',
  styleUrl: './notification-add-recipients-template.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
      trigger('detailExpand', [
        state('collapsed, void', style({ height: '0px', minHeight: '0' })),
        state('expanded', style({ height: '*' })),
        transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      ]),
    ],

})
export class NotificationAddRecipientsTemplateComponent {
  // displayedColumns = ['select', 'customerID', 'customerName', 'customerContactName', 'customerContactEmail', 'source','iconSets'];
  dataSource = this._notificationAddRecipientService.list$;
    sortInfo: { column: string, direction: string }[] = [{ column: 'DateDelivered', direction: 'desc' }];
  @Input() public duplicates$: Subject<any[]>;
  public duplicates: any[] = [];
  private subscription;
  public expandedElement: any | null = null;
  //  selection = new SelectionModel<TableElement>(true, []);
  controls: FormArray;
  selectedRows: any[] = [];
  @Output() selectionChanged = new EventEmitter<number>();
  lastUpdate;
  expandedRowIndex: number | null = null; 
  @Input() public addRowData: Subject<any>;
  @Output() public isFeedbackOptionAdded = new EventEmitter<{ isOptAdded: boolean; isSendNotificationDisable: boolean }>();
  @Output() public isFoRowSelected = new EventEmitter<{ rowSelected: any }>();
  @Output() public isRecipientAdded = new EventEmitter<{ control: any }>();
  @Input() public isDeleteDisabledCheck:Subject<any>;
  @Input() public contactList: any = [];
   @Input() public isNewFromTemplate: boolean = false;
  @Input() public displayedColumns: string[] = [];
  @Input() public tableData: any[] = [];
  
  
  public duplicatesList: any = [];
  public attemptedConfirm: Set<number> = new Set<number>();
 

  constructor(private changeDetectorRef: ChangeDetectorRef,private _notificationAddRecipientService: NotificationAddRecipientService,private _QnSbnService:QnSbnService) {}
  ngOnInit() {
    this.subscription = this.duplicates$.subscribe((duplicates) => {
      this.duplicates = duplicates;
    });
  
    
    const toGroups = this._notificationAddRecipientService.list$.value.map(entity => {
      return new FormGroup(
        {
          customerID: new FormControl(entity.customerID, Validators.required),
          customerName: new FormControl(entity.customerName, Validators.required),
          customerContactName: new FormControl(entity.customerContactName, Validators.required),
          customerContactEmail: new FormControl(entity.customerContactEmail, Validators.required),
          source: new FormControl(entity.source, Validators.required),
          internalContact: new FormControl(entity.internalContact ?? false),
        },
        { updateOn: 'change' }
      );
    });
   
    this.controls = new FormArray(toGroups);
    this.addRowData.subscribe(data=>{
   
      
      if(data === "Manual"){ 
        this.addRecipientManual();
      }else{
        this.addRecipientImportFile(data);
      }
    })
  
    this.isDeleteRows();

    this.dataSource.subscribe(
      d=>{
        if (d.length === 0) {
          this.controls.clear();
          this.attemptedConfirm.clear();
        }
        this.changeDetectorRef.detectChanges();
      }
    )
  }

  isSelected(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  toggleSelection(row: any): void {
    const idx = this.selectedRows.indexOf(row);
    if (idx > -1) {
      this.selectedRows.splice(idx, 1);
    } else {
      this.selectedRows.push(row);
    }
    this.selectionChanged.emit(this.selectedRows.length);
  }

  isAllSelected(): boolean {
    const data = this.dataSource.value || [];
    return data.length > 0 && this.selectedRows.length === data.length;
  }

  isIndeterminate(): boolean {
    const data = this.dataSource.value || [];
    return this.selectedRows.length > 0 && !this.isAllSelected();
  }

  masterToggle(): void {
    const data = this.dataSource.value || [];
    if (this.isAllSelected()) {
      this.selectedRows = [];
    } else {
      this.selectedRows = data.slice();
    }
    this.selectionChanged.emit(this.selectedRows.length);
  }
 isDeleteRows(){
    this.isDeleteDisabledCheck.subscribe(d=>{
      if(d =="deleteClicked"){
        this.selectedRows.forEach((selectEle,j)=>{
        const index = this._notificationAddRecipientService.list.indexOf(selectEle);
          this.controls.value.map((ctrlEle,i)=>{
            if(JSON.stringify(selectEle) === JSON.stringify(ctrlEle) && index === i){                       
              this.controls.controls.splice(i,1);
              this.controls.value.splice(i,1);      

              this._notificationAddRecipientService.changeUpdate(i,this.trimSpaces(this.controls.value))
            }
          }) 
        });
        this.selectedRows.length=0;
        this.selectedRows = [];
        // this.isUnChecked();

        this._notificationAddRecipientService.changeUpdate(0,this.trimSpaces(this.controls.value))

        this._notificationAddRecipientService.addRecipientsControls.next({name:'delete',control:this.controls})
         this.isRecipientAdded.emit({control:this.controls})
        this.changeDetectorRef.detectChanges();
      }
    })
  }

//  isAllSelected(): boolean {
//   const data = this._notificationAddRecipientService.list;
//   return data.length > 0 && this.selection.selected.length === data.length;
// }

// masterToggle(): void {
//   const data = this._notificationAddRecipientService.list;
//   this.isAllSelected()
//     ? this.selection.clear()
//     : data.forEach(row => { if (!row.disabled) this.selection.select(row); });
//   this.onSelectionChange();
// }

// onSelectionChange(): void {
//   // Emit or handle selection changes as needed
//   if (this.selection.selected.length === 0) {
//     this.isFoRowSelected.emit({ rowSelected: true });
//   } else {
//     this.isFoRowSelected.emit({ rowSelected: false });
//   }
//   this._notificationAddRecipientService.addRecipientsControls.next({ name: 'checked', control: this.controls });
// }

  // isUnChecked(){
  //   if(this.selection.selected.length==0){
  //     this.isFoRowSelected.emit({rowSelected:true})
  //     this._notificationAddRecipientService.addRecipientsControls.next({name:'unchecked',control:this.controls})
  //   }
  // }


  public addRecipientManual(){
    this.controls.push(new FormGroup(
      {
        customerID: new FormControl("", Validators.required),
        customerName: new FormControl("", Validators.required),
        customerContactName: new FormControl("", Validators.required),
        customerContactEmail: new FormControl("", Validators.required),
        source: new FormControl("", Validators.required),
        internalContact: new FormControl(false),
      },
      { updateOn: 'change'}
    ))
    this._notificationAddRecipientService.add();  

    this._notificationAddRecipientService.addRecipientsControls.next({name:'add',control:this.controls})
  }

  public addRecipientImportFile(filedata){
    filedata.map(data => {
      let columnName = Object.keys(data);
      let build_array=new FormGroup({
        customerID: new FormControl(data[columnName[0]], Validators.required),
        customerName: new FormControl(data[columnName[1]], Validators.required),
        customerContactName: new FormControl(data[columnName[2]], Validators.required),
        customerContactEmail: new FormControl(data[columnName[3]], Validators.required),
        source: new FormControl(data[columnName[4]], Validators.required),
        internalContact: new FormControl(false),
      },
        { updateOn: 'change'}
      );
      this.controls.push(build_array); 

      return build_array;
    })

    this._notificationAddRecipientService.changeUpdate(0,this.trimSpaces(this.controls.value))

    this._notificationAddRecipientService.addRecipientsControls.next({name:'importByFile',control:this.controls})

    this.isRecipientAdded.emit({control:this.trimSpaces(this._notificationAddRecipientService.list)});
    
    this.duplicatesList = this.findObjectDuplicates(this.trimSpaces(this.contactList), this.trimSpaces(this._notificationAddRecipientService.list));
  }

  updateField(index, field) {
    const control = this.getControl(index, field);
    if (control.valid) {
      this._notificationAddRecipientService.update(index, field, this.trimSpaces(control.value));

      this.lastUpdate = {
        index,
        field,
        value: this.trimSpaces(control.value)
      };
    }
  }

  getControl(index, fieldName) {
    return this.controls.at(index).get(fieldName) as FormControl;
  }

  toggleInternalContact(index: number): void {
    const ctrl = this.getControl(index, 'internalContact');
    ctrl.setValue(!ctrl.value);
    this._notificationAddRecipientService.update(index, 'internalContact', ctrl.value);
  }

  addNewNotificationRecipient(ele,i,iconClick):void{    
    if(iconClick === 'no'){
      this.controls.value.pop();
      this.controls.controls.pop();
      this.attemptedConfirm.delete(i);
    }else{
      const formGroup = this.controls.at(i) as FormGroup;
      Object.keys(formGroup.controls).forEach(key => {
        formGroup.get(key)?.markAsTouched();
      });

      if(formGroup.invalid) {
        this.attemptedConfirm.add(i);
        this.changeDetectorRef.detectChanges();
        return;
      }
      
      this.controls.value[i]['iconSets'] = "";
      this.attemptedConfirm.delete(i);
    }   

    this._notificationAddRecipientService.changeUpdate(i,this.trimSpaces(this.controls.value));

    this._notificationAddRecipientService.addRecipientsControls.next({name:'update',control:this.controls})

    this.isRecipientAdded.emit({control:this._notificationAddRecipientService.list})
    let checkLength = this.controls.controls.length > 0;
    const isOptAdded = this.controls.controls.length === 0 ? true : true;
    this.isFeedbackOptionAdded.emit({ isOptAdded: isOptAdded, isSendNotificationDisable: checkLength });

    this.duplicatesList = this.findObjectDuplicates(this.trimSpaces(this.contactList), this.trimSpaces(this._notificationAddRecipientService.list));
  }

  public findObjectDuplicates(array1, array2) {
    const set1 = new Set();
    const set2 = new Map();
    const duplicates = [];

    // Helper function to add keys to the set1
    function addToSet(set, item) {
        set.add(`id:${item.customerID}|email:${item.customerContactEmail}`);
    }

    // Add unique keys from array1 to set1
    array1.forEach(item => {
        addToSet(set1, item);
    });

    // Check array2 against set1 and itself
    array2.forEach(item => {
        const keyEmail = `id:${item.customerID}|email:${item.customerContactEmail}`;
        const keyName = `id:${item.customerID}|name:${item.customerName}`;

        // Condition 1: id and email are the same
        if (set1.has(keyEmail) || set2.has(keyEmail)) {
            duplicates.push(item);
        }

        // Condition 2: id is the same but name is different
        const existingItem = set2.get(`id:${item.customerID}`);
        if (existingItem && existingItem.customerName !== item.customerName) {
            duplicates.push(item);
        }

        // Add the item to set2 to track duplicates within array2
        set2.set(`id:${item.customerID}`, item);
        set2.set(keyEmail, item);
    });

    return duplicates;
  }


  public isDuplicated(target){
    return this.compareObjectToExistingArray(target, this.duplicatesList)
  }

  public compareObjectToExistingArray(obj, arr) {
    return arr.some(item => this.isEqual(obj, item));
  }

  public isEqual(obj1, obj2) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    return keys1.every(key => obj1[key] === obj2[key]);
  }

  trimSpaces(data){
    data.map(i=>{
      if(i.customerContactName!==undefined || '' || null){
        i.customerContactName=i.customerContactName.trim()
      } 
      if(i.customerContactEmail !== undefined && i.customerContactEmail !== null && i.customerContactEmail !== ''){
        i.customerContactEmail = i.customerContactEmail.trim()
      } 
      if(i.customerID !== undefined && i.customerID !== null && i.customerID !== ''){
        i.customerID = i.customerID.trim()
      }
      if(i.customerName !== undefined && i.customerName !== null && i.customerName !== ''){
        i.customerName = i.customerName.trim()
      }
      if(i.source !== undefined && i.source !== null && i.source !== ''){
        i.source = i.source.trim()
      }
    })
    return data;
  }

  public isDuplicate(d: any, target: any): boolean{
    if(!d || !target) return false;
    return this.isDuplicatedEmail(d, target) || this.isDuplicatedName(d, target);
  }

  public isDuplicatedEmail(d: any[], target: any): boolean{
    if(!d || !target) return false;
    const isBlank = (v: any) => v === undefined || v === null || String(v).trim() === '';
    // A row without a customerID is not yet a real entry — never treat it as a duplicate.
    if (isBlank(target.customerID)) return false;

    const duplicateInContactList = this.contactList.some(obj => 
      !isBlank(obj.CustomerId) &&
      obj.CustomerId === target.customerID &&
      obj.CustomerContactEmail === target.customerContactEmail
    );
    
    if(duplicateInContactList) {
      return true;
    }
    
    const targetIndex = d.indexOf(target);
    const duplicateInArray = d.some((obj, index) => {
        return index !== targetIndex && 
        !isBlank(obj.customerID) &&
        obj.customerID === target.customerID &&
        obj.customerContactEmail === target.customerContactEmail
    });
    return duplicateInArray;
  }

  public isDuplicatedName(d: any, target: any): boolean{
    if(!d || !target) return false;
    const isBlank = (v: any) => v === undefined || v === null || String(v).trim() === '';
    if (isBlank(target.customerID)) return false;
    
    const duplicateNameInContactList = this.contactList.some(obj => 
      !isBlank(obj.CustomerId) &&
      obj.CustomerId === target.customerID &&
      obj.CustomerName !== target.customerName
    );
    
    if(duplicateNameInContactList) {
      return true;
    }
    
    const targetIndex = d.indexOf(target);
    const duplicateNameInArray = d.some((obj, index) => 
      index !== targetIndex && 
      !isBlank(obj.customerID) &&
      obj.customerID === target.customerID && 
      obj.customerName !== target.customerName
    );
    return duplicateNameInArray;
  }

   isEmpty(data, index?: number){
    if (index !== undefined && this.controls && this.controls.at(index)) {
      if (!this.attemptedConfirm.has(index)) {
        return false;
      }
      
      const formGroup = this.controls.at(index);
      const customerContactName = (formGroup.get('customerContactName')?.value || '').trim();
      const customerContactEmail = (formGroup.get('customerContactEmail')?.value || '').trim();
      const customerID = (formGroup.get('customerID')?.value || '').toString().trim();
      const customerName = (formGroup.get('customerName')?.value || '').trim();
      const source = (formGroup.get('source')?.value || '').trim();
      
      if (!customerContactName || !customerContactEmail || !customerID || !customerName || !source){
        return true;
      }
      return false;
    }
    
    const customerContactName = (data.customerContactName || '').trim();
    const customerContactEmail = (data.customerContactEmail || '').trim();
    const customerID = (data.customerID || '').toString().trim();
    const customerName = (data.customerName || '').trim();
    const source = (data.source || '').trim();
    
    if (!customerContactName || !customerContactEmail || !customerID || !customerName || !source){
          return true
    }
    return false
  }

  expandToggle(element: any) {
    const currentData = this._notificationAddRecipientService.list$.value;
    const elementIndex = currentData.findIndex(item => 
      item.customerID === element.customerID && 
      item.customerContactEmail === element.customerContactEmail
    );
    if (this.expandedRowIndex === elementIndex) {
      this.expandedRowIndex = null;
      this.expandedElement = null;
    } else {
      this.expandedRowIndex = elementIndex;
      this.expandedElement = element;
    }
    this.changeDetectorRef.detectChanges();
  }

  isExpanded(row: any) {
    return row === this.expandedElement;
  }

  isRowExpanded(row: any): boolean {
    const currentData = this._notificationAddRecipientService.list$.value;
    const rowIndex = currentData.findIndex(item => 
      item.customerID === row.customerID && 
      item.customerContactEmail === row.customerContactEmail
    );
    const hasWarnings = this.isDuplicate(this.duplicates, row) || this.isEmpty(row);
    const isExpanded = this.expandedRowIndex === rowIndex;
    const shouldShow = hasWarnings && isExpanded;
    return shouldShow;
  }

  isExpandedRow = (index: number, row: any) => {
    return this.isRowExpanded(row);
  };

   public OnSort(column: string, value: string): void {
    const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
    if (existingSortIndex !== -1) {
      this.sortInfo.splice(existingSortIndex, 1);
    }
    if (value !== 'default') {
      this.sortInfo.push({ column, direction: value });
    }
    this.dataSource.next(this.applySorting(this.dataSource.value));
    this.changeDetectorRef.detectChanges();
  }

  applySorting(data: any[]): any[] {
    const dataCopy = [...data];
    if (this.sortInfo.length > 0) {
      return dataCopy.sort((a, b) => {
        for (let i = this.sortInfo.length - 1; i >= 0; i--) {
          const { column, direction } = this.sortInfo[i];
          const aValue = a[column] ?? '';
          const bValue = b[column] ?? '';
          if (aValue < bValue) return direction === 'asc' ? -1 : 1;
          if (aValue > bValue) return direction === 'asc' ? 1 : -1;
        }
        return 0;
      });
    }
    return dataCopy;
  }

}

